/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TDesktopGetNotificationsModel,
  IDesktopGetNotificationsRequest,
  IMappers,
  IDesktopGetNotificationsResponse,
  IDesktopGetNotificationsResponseError,
  TDesktopGetNotificationsResponse,
} from './types';

const defaultConfig: TDesktopGetNotificationsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'notification-center',
  pathApi: '/v1/desktop/get-notifications/',
  hostType: 'api',
} as TDesktopGetNotificationsModel;

function createDesktopGetNotificationsModel(
  parameters: IDesktopGetNotificationsRequest,
): TDesktopGetNotificationsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IDesktopGetNotificationsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IDesktopGetNotificationsRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchDesktopGetNotifications<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IDesktopGetNotificationsOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TDesktopGetNotificationsResponse
> {
  const { response, statusCode } = await httpApi.fetch(createDesktopGetNotificationsModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IDesktopGetNotificationsResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IDesktopGetNotificationsResponseError);
    }
  }

  return { response, statusCode } as TDesktopGetNotificationsResponse;
}

export { defaultConfig, createDesktopGetNotificationsModel, fetchDesktopGetNotifications };
